module.exports = __webpack_public_path__ + "static/media/03.27ce2469.jpg";